<template>
  <v-dialog v-model="showModalInternal" max-width="450">
    <v-card>
      <v-card-title>{{ trans('settlement.create') }}</v-card-title>
      <v-card-text>
        <div class="my-3">
          <date-select
            v-model="dateInternal"
            type="month"
            :label="trans('general.monthYear')"
            :clearable="false"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="showModalInternal = false"></cancel-button>
        <v-btn color="primary" @click="createSettlementAndStartBookingUpdate">{{ trans('settlement.create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CancelButton from './CancelButton'
import {LocaleUtils} from '../utils/locale-utils';
import dayjs from 'dayjs';
import {RouterUtils} from '../utils/router-utils';
import {SettlementApi} from '@/api/settlement-api';
import {MainUtils} from '@/utils/main-utils';
import DateSelect from './DateSelect';

export default {
  name: 'SettlementCreateModal',
  mixins: [
    MainUtils,
    LocaleUtils,
    RouterUtils
  ],
  components: {DateSelect, CancelButton},
  props: {
    showModal: {}
  },
  data () {
    return {
      showModalInternal: false,
      dateInternal: null
    }
  },
  mounted () {
    let dayOfMonth = dayjs().date();
    let date = dayjs().startOf('month');

    if (dayOfMonth <= 15) {
      date = date.subtract(1, 'day');
    }

    this.dateInternal = date.format('YYYY-MM');
  },
  methods: {
    createSettlementAndStartBookingUpdate () {
      let date = dayjs(this.dateInternal);
      SettlementApi.createSettlement(date.year(), date.month() + 1)
      .then(response => {
        this.pushToRoute('SettlementUpdateBookings', {settlementId: response.body.id})
      })
      .catch(this.handleErrorResponse)
    }
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  }
}
</script>
